import { render, staticRenderFns } from "./EndorseButton.vue?vue&type=template&id=0a1a2de3&"
import script from "./EndorseButton.vue?vue&type=script&lang=ts&"
export * from "./EndorseButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports